import { useMemo } from 'react'

export interface ProxyConfig {
  proxyUrl: string | null
  proxyToken: string | null
  appVersion: string | null
  isElectron: boolean
}

const STORAGE_KEY_URL     = 'proxy_url'
const STORAGE_KEY_TOKEN   = 'proxy_token'
const STORAGE_KEY_VERSION = 'proxy_app_version'

// Called once at app startup before the router redirects strip query params.
export function initProxyConfig(): void {
  const params = new URLSearchParams(window.location.search)
  const proxyUrl   = params.get('proxyUrl')
  const proxyToken = params.get('proxyToken')
  const appVersion = params.get('appVersion')
  if (proxyUrl && proxyToken) {
    sessionStorage.setItem(STORAGE_KEY_URL,   proxyUrl)
    sessionStorage.setItem(STORAGE_KEY_TOKEN, proxyToken)
    if (appVersion) sessionStorage.setItem(STORAGE_KEY_VERSION, appVersion)
  }
}

export function useProxyConfig(): ProxyConfig {
  return useMemo(() => {
    const proxyUrl   = sessionStorage.getItem(STORAGE_KEY_URL)
    const proxyToken = sessionStorage.getItem(STORAGE_KEY_TOKEN)
    const appVersion = sessionStorage.getItem(STORAGE_KEY_VERSION)
    return {
      proxyUrl,
      proxyToken,
      appVersion,
      isElectron: proxyUrl !== null && proxyToken !== null,
    }
  }, [])
}
